<template>
  <div class="bannerbox">
    <div class="bannerimgbox" v-if="bannerArr.length == 1">
      <a :href="bannerArr[0].myLink" v-if="bannerArr[0].myLink != null" target="_blank"><img :src="bannerArr[0].imgUrl" alt=""></a>
      <img :src="bannerArr[0].imgUrl" alt="" v-else>
    </div>

    <div class="" v-else-if="bannerArr.length > 1">
      <Carousel autoplay v-model="value1" loop>
        <CarouselItem v-for="(banner,index) in bannerArr" :key="index">
              <div class="demo-carousel" >
                <a :href="banner.myLink" v-if="banner.myLink != null" target="_blank"><img :src="banner.imgUrl" alt=""></a>
                <img :src="banner.imgUrl" alt="" v-else>
              </div>
          </CarouselItem>
       </Carousel>
    </div>
  </div>


</template>
<script>
  import api from '../../utils/api.js'
  export default {
    name:'indexBanner',
    props:{
      bannerData:{
        type:Object,
        default:{}
      }
    },
    data() {
      return {
        imglen:2,
        bannerList: [],
        dataobj: {},
        bannerArr:[],
        value1:0,
        picId:''
      }
    },
    mounted() {
      this.bannerList = this.bannerData.banners;
      this.getAxtLunboSourceList()
      this.getpicId()
    },
    computed:{
      fesetData(){
        return(arr)=>{
          return arr && arr.length > 0?arr:[]
        }
      }
    },
    methods:{
      getpicId(){
        let pic = [];
        for(var i=0;i<this.bannerList.length;i++){
          pic.push(this.bannerList[i].picId)
        }
        this.picId = pic.join(",")
        if(this.picId){
          this.getAxtLunboSourceList()
        }
      },
      getAxtLunboSourceList(ids){
        let websiteId = localStorage.getItem('websiteId');
        const that = this;
        const url = '/axt-mhcz/axtLunboSource/getAxtLunboSourceList';
         // console.log(params,"params")
         const params = {
           website_id: websiteId,
           ids: this.picId
         }
         if(this.picId == ''){
           return
         }
          // console.log(params, "params")
         api.getListAPI(url, params).then(res => {
           if (res.data.message == 'success') {
             this.bannerArr = res.data.data.rows;
           }
         })

      },
    }
  }
</script>
<style>
  .bannerbox .ivu-carousel-list {
    max-height: 500px;
    overflow: hidden;
  }
</style>
<style scoped>
  .swiper-container {
    display: flex;
    width: 100%;

  }
  .bannerbox {
    width: 100%;
    height: auto;
  }
  .bannerbox img {
    display: block;
    width: 100%;
  }
  .swiper-slide {
    overflow: auto;
    line-height: 1;
  }
  .swiper-slide img {
    display: block;
    line-height: 1;
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/Banner.vue